import { render, staticRenderFns } from "./CulturePromotionContentType.vue?vue&type=template&id=79675766&scoped=true&"
import script from "./CulturePromotionContentType.vue?vue&type=script&lang=js&"
export * from "./CulturePromotionContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79675766",
  null
  
)

export default component.exports